import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const vulnerabilitiesDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.methodologySection',
        popover: {
          title: 'Vulnerability Assessment Methodology',
          description:
            'This section explains the methodology used to identify and assess vulnerabilities. Understanding this process helps you interpret the findings accurately.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVulnerability',
        popover: {
          title: 'Report New Vulnerability',
          description:
            'Use this feature to document and report a new vulnerability. Ensure all relevant details are included to facilitate proper risk assessment and remediation.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.projectsData',
        popover: {
          title: 'Project Data',
          description:
            'View and manage data related to specific projects. This includes vulnerability findings, project scope, and risk levels.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.findByRank',
        popover: {
          title: 'Filter by Risk Rank',
          description:
            'Filter vulnerabilities based on their risk rank. This helps prioritize the most critical issues that need immediate attention.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.criticalAndHighVulnerabilities',
        popover: {
          title: 'Critical and High Vulnerabilities',
          description:
            'This section highlights vulnerabilities classified as critical. Addressing these should be a top priority.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.assignedVulnerabilities',
        popover: {
          title: 'Assigned Vulnerabilities',
          description:
            'View vulnerabilities that have been assigned to specific team members for remediation. This helps track who is responsible for addressing each issue.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.vulnerabilitiesTableDetail',
        popover: {
          title: 'Vulnerability Details Table',
          description:
            'This table provides detailed information about all identified vulnerabilities, including their status, risk level, etc',
          side: 'top',
          align: 'end',
        },
      },
    ],
  });
  return driverObj;
};
export default vulnerabilitiesDriverObj;
